import { render, staticRenderFns } from "./CourseParticipantsDialog.vue?vue&type=template&id=7a451675&scoped=true&"
import script from "./CourseParticipantsDialog.vue?vue&type=script&lang=ts&"
export * from "./CourseParticipantsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CourseParticipantsDialog.vue?vue&type=style&index=0&id=7a451675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a451675",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
